import * as React from 'react';
import { WebPage } from '@grandvisionhq/analytics';
import { useProductData } from '../../../context/ProductContext.js';

const WebPageSchema = ()=>{
    const { activeVariant: { description  } , product: { brandName  } , productUrl ,  } = useProductData();
    return /*#__PURE__*/ React.createElement(WebPage, {
        url: productUrl,
        pageType: "ProductDetail",
        name: brandName,
        description: description
    });
};

export { WebPageSchema };
//# sourceMappingURL=WebPageSchema.js.map
